export default "__VITE_ASSET__CuU550sL__"